<div class="d-block w-100">
    <ul class="list-unstyled" id="refundSearchFields">
        <li>
            <div class="tab w-100">
                <button #dateCreated
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == dateCreated.id}"
                        id="dateCreatedFilter">
                    Date&nbsp;Created <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #accountNo
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == accountNo.id}"
                        id="accountNumberFilter">
                    Account&nbsp;Number <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #reference
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == reference.id}"
                        id="referenceNumberFilter">
                    Reference <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #name
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == name.id}"
                        id="nameFilter">
                    Name <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #amount
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == amount.id}"
                        id="amountFilter">
                    Amount <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #status
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == status.id}"
                        id="statusFilter">
                    Status <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #shop
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == shop.id}"
                        id="ecommerceStoreFilter">
                    Shop <em class="dropdown-toggle" style="float: right"></em>
                </button>
                <button #period
                        type="button"
                        (click)="getTabContent($event)"
                        [ngClass]="{'active':activeTab == period.id}"
                        id="periodFilter">
                    Period <em class="dropdown-toggle" style="float: right"></em>
                </button>
            </div>
            <form [formGroup]="form" (ngSubmit)="search()">
                <div>
                    @switch (activeTab) {
                        @case (period.id) {
                            <div class="tabcontent">
                                <p-select [options]="periodOptions"
                                          [ngModel]="selectedPeriod"
                                          [ngModelOptions]="{standalone: true}"
                                          (onChange)="onPeriodChange($event.value)"
                                          class="form-control"
                                          optionLabel="label"
                                          optionValue="value"
                                          placeholder="Period"></p-select>
                            </div>
                        }
                        @case (dateCreated.id) {
                            <div class="tabcontent">
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimeCreatedLower">From:</label>
                                    <input class="form-control d-inline"
                                           formControlName="dateTimeCreatedLower"
                                           id="dateTimeCreatedLower"
                                           type="date"/>
                                </div>
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimeCreatedUpper">To:</label>
                                    <input class="form-control d-inline"
                                           formControlName="dateTimeCreatedUpper"
                                           id="dateTimeCreatedUpper"
                                           type="date"/>
                                </div>
                            </div>
                        }
                        @case (accountNo.id) {
                            <div class="tabcontent">
                                <input class="form-control"
                                       formControlName="accountNumber"
                                       id="accountNumber"
                                       placeholder="Account Number"
                                       type="text"/>
                            </div>
                        }
                        @case (reference.id) {
                            <div class="tabcontent">
                                <input class="form-control"
                                       formControlName="referenceNumber"
                                       id="referenceNumber"
                                       placeholder="Reference"
                                       type="text"/>
                            </div>
                        }
                        @case (name.id) {
                            <div class="tabcontent">
                                <input class="form-control"
                                       formControlName="customer"
                                       id="customer"
                                       placeholder="Name"
                                       type="text"/>
                            </div>
                        }
                        @case (amount.id) {
                            <div class="tabcontent">
                                <input class="form-control"
                                       formControlName="amountLower"
                                       id="amountLower"
                                       min="0"
                                       placeholder="Lower Limit"
                                       type="number"/>
                                <input class="form-control"
                                       formControlName="amountUpper"
                                       id="amountUpper"
                                       min="0"
                                       placeholder="Upper Limit"
                                       type="number"/>
                            </div>
                        }
                        @case (status.id) {
                            <div class="tabcontent">
                                <p-select [options]="statusOptions"
                                          formControlName="refundState"
                                          class="form-control"
                                          id="refundState"
                                          optionLabel="label"
                                          optionValue="value"></p-select>
                            </div>
                        }
                        @case (shop.id) {
                            <div class="tabcontent">
                                <select class="form-control"
                                        formControlName="ecommerceStoreIds"
                                        id="ecommerceStoreIds">
                                    <option value="">All Shops</option>
                                    @for (storeOption of ecommerceStoreOptions; track storeOption.value) {
                                        <option [value]="storeOption.value">{{ storeOption.label }}</option>
                                    }
                                </select>
                            </div>
                        }
                    }
                </div>
                <div class="row">
                    <div [hidden]="!tabActive" class="col-md-12 text-center">
                        <button (click)="clear(activeTab)"
                                class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="button">
                            Clear
                        </button>
                        <button (click)="clearAll()"
                                class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="button">
                            Clear All
                        </button>
                        <button class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="submit">
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </li>
    </ul>
</div>
